import Alpine from 'alpinejs';

require('./components/counter')
require('./components/cursor')
require('./components/footer')
require('./components/mobile-menu')
require('./components/swiper')
require('./components/video')

window.Alpine = Alpine;
Alpine.start();
